import { Reducer } from "../../lib/redux";
import { IAnnotation } from "../../model/DutyStatusLog";
import { HosAnnotationActions } from "./actions";
import { HOSAnnotationActionTypes } from "./types";
import { extend } from "../../utils/vanilla";

export const defaultAnnotations: IIdDictionary<IIdDictionary<IAnnotation>> = {};

export const hosAnnotations: Reducer<IIdDictionary<IIdDictionary<IAnnotation>>, HosAnnotationActions> = (state = defaultAnnotations, action) => {
    switch (action.type) {
        case HOSAnnotationActionTypes.SET_ANNOTATIONS: {
            return {
                ...state,
                [action.payload.userId]: extend(true, {}, action.payload.annotations)
            };
        }
        case HOSAnnotationActionTypes.CLEAR_ANNOTATIONS: {
            let newState = { ...state };
            delete newState[action.payload];
            return newState;
        }
        default:
            return state;
    }
};